import { PostFormResponse } from 'types';
import { CheckCircleIcon } from 'static/icons';
import { Heading, Text } from 'components';
import { FontSize, FontWeight } from 'commons';
import * as S from './styles';

interface SuccessProps {
  response: PostFormResponse;
}

export function Success({ response }: SuccessProps) {
  return (
    <S.Wrapper>
      <S.CheckWrapper>
        <CheckCircleIcon />
      </S.CheckWrapper>
      <S.TextWrapper>
        <Heading as="h1" size={FontSize.font16} weight={FontWeight.bold}>
          Sua solicitação foi enviada!
        </Heading>
        <Text>
          Sua solicitação de troca ou devolução foi enviada para nossa equipe de
          atendimento. <br /> Acompanhe o progresso do atendimento através do
          protocolo <strong>{response.ticketId}</strong>.
        </Text>
      </S.TextWrapper>
    </S.Wrapper>
  );
}
